export default __webpack_public_path__ + "static/media/linkedin.d8fff576.svg";